import { Link } from "react-router-dom";
import React from "react";
import { Helmet } from "react-helmet";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import "bootstrap/dist/css/bootstrap.min.css";
// import ass from "../assets/images/image.jpeg";
// import logo from "../assets/images/logo.png"
// import confer from "/images/cop1.jpg"
// import confer1 from "/images/cop1.jpg"

const TajBusinessConnect = () => {
  return (
      <>
  <Helmet>

    <title>V Hotel Pass Loyalty Program - The Grand Shoba, Delhi</title>

<meta name="description" content="Join the V Hotel Pass loyalty program at The Grand Shoba in Mahipalpur, Delhi. Earn V Coins, enjoy exclusive room rates, and indulge in premium perks at our luxury hotel near IGI Airport." />
<meta name="keywords" content="V Hotel Pass, V Hotel loyalty program, earn V Coins, hotel rewards Delhi, exclusive room rates Mahipalpur, business hotel IGI Airport, luxury hotel offers, The Grand Shoba loyalty, premium hotel deals Delhi" />

{/* <!-- Open Graph (for Facebook, LinkedIn, etc.) --> */}
<meta property="og:title" content="V Hotel Pass Loyalty Program - The Grand Shoba" />
<meta property="og:description" content="Unlock exclusive hotel rewards with V Hotel Pass. Earn V Coins, save on luxury stays, and enjoy elite perks across V Hotel properties near IGI Airport, Delhi." />
<meta property="og:image" content="https://www.vhotelthegrandshoba.com/images/loyalty/loyalty-banner.jpg" />
<meta property="og:url" content="https://www.vhotelthegrandshoba.com/loyalty" />
<meta property="og:type" content="website" />

{/* <!-- Twitter Card --> */}
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:title" content="V Hotel Pass Loyalty Program - Delhi" />
<meta name="twitter:description" content="Join V Hotel Pass and enjoy exclusive rewards, V Coins, and luxury experiences at The Grand Shoba, Mahipalpur—near IGI Airport, New Delhi." />
<meta name="twitter:image" content="https://www.vhotelthegrandshoba.com" />

  </Helmet>

    <div>
     

      {/* Main Section */}
      <div className="container mt-5">
        <div className="row align-items-center">
          <div className="taj-bussiness-main">
          <div className="col-md-6   col-12">
            <LazyLoadImage
              src= "/images/corpo/corporate-sub.jpg"
              alt="V Hotel The Grnad Shoba about-image"  loading="lazy" title="A WORLD OF PRIVILEGES AND BENEFITS V Hotel The Grnad Shoba"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6   col-12 taj-bussiness-des  mt-4">
            <h2 className="fw-bold">A WORLD OF PRIVILEGES AND BENEFITS</h2>
            <p className="mt-3">
            Unlock a host of elevated experiences and unmatched rewards with the V hotel Pass loyalty program. Enjoy exclusive room rates, earn and redeem V Coins, and indulge in premium benefits across all V Hotel properties in Mahipalpur, Delhi, and beyond. Whether you're staying for leisure or business, our membership enhances every stay with plush comforts, gourmet dining, and seamless services at V Hotel The Grand Shoba.</p>
            <div className="d-flex corpo-bussiness-main gap-5">
              <div className="corpo-business-btn">
                <Link to="/corporate-query"> <button className=" corpo-business-btn  ">QUERY</button></Link></div> 
              
                 <div className="corpo-business-btn">   
                 <Link to="/gallery">  <button className=" corpo-business-btn ">View Gallery</button> </Link>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default TajBusinessConnect;
